// extracted by mini-css-extract-plugin
module.exports = {"container":"CTIY34","carousel":"LjgQt8","plan":"qkayqA","list":"_2KXEPb"};